module.exports = __webpack_public_path__ + "fonts/BebasNeueBook.72e92b97.ttf";